import {
  EnvironmentConfig,
  environmentDefaults,
  featureFlagDefaults,
  oidcDefault,
} from '@cigna/chcp/shared/environment-util';

export const environment: EnvironmentConfig = {
  ...environmentDefaults,
  oidc: {
    ...oidcDefault,
    secureUris: [
      'https://p-chcp.digitaledge.cigna.com',
      'https://p-gsg.digitaledge.cigna.com',
      '/prv/secure',
    ],
  },
  redirect: {
    crossOrigin: {
      domain: 'https://provider.evernorth.com',
    },
    mhk: '/isam/sps/chcp-p-idp-mhk/saml20/logininitial?PartnerId=https://cignaportal.medhokapps.com/pportal',
    hsConnect: 'https://healthspring.hsconnectonline.com',
    inbox:
      '/isam/sps/chcp-p-idp-proofpoint/saml20/logininitial?PartnerId=https://saml-entity-id.proofpoint.com/cigna_hosted-pe3',
  },
  omni: {
    sonicNotification: 'https://static.cigna.com/spa/chcp/',
    identityUrl: 'https://p-chcp.digitaledge.cigna.com/converse/identity',
    botUrl: 'https://p-chcp.digitaledge.cigna.com/converse/bot',
    liveUrl: 'https://p-chcp.digitaledge.cigna.com/converse/live/user',
    publicUrl: 'https://p-chcp.digitaledge.cigna.com/converse',
  },

  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: 'https://static.cigna.com/',
      resourceContent: 'https://p-digital-static.digitaledge.cigna.com/',
      secureApi: 'https://p-chcp.digitaledge.cigna.com',
      publicApi: 'https://p-chcp.digitaledge.cigna.com/public',
      gsgPublicApi: 'https://p-gsg.digitaledge.cigna.com/public',
      gsgSecureApi: 'https://p-gsg.digitaledge.cigna.com',
      graphql: 'https://p-chcp.digitaledge.cigna.com/apollo-graphql',
    },
    searchIndex: 'prod',
    salesDemo: false,
  },
  trustId: '5045161',
  features: {
    ...featureFlagDefaults,
    nextRelease: false,
    patientEnhBehaviorStandalone: false,
    patientEnhPower: false,
    messageCenterPrefWAM: false,
    messageCenterPreference: false,
    messageCenterDashboard: true,
    precertManual: false,
    emailVerifyPopup: false,
    claim360SearchOffice: false,
    allowTempIdPassAddition: false,
    gqlPatientDetails: true,
    gqlClaimDetails: true,
    manageAccessTilePagination: true,
    findLOBAwsOperations: true,
    createUserAwsOperations: true,
    hasRestrictedChat: true,
    shouldEnableChat: true,
    showNewChatBubble: true,
    enableNewPreChatWelcome: true,
    emailTinChanges: true,
    eftMedicalAws: false,
    loginUserProfileAWS: false,
  },
};
